class CardGridFilter extends HTMLElement {
  filterGrid = null;
  items = [];
  state = {};

  constructor() {
    super();

    this.filterGrid = this.querySelector('filter-grid');
    this.items = this.querySelectorAll('.card');

    if (this.filterGrid) {
      customElements.whenDefined('filter-grid').then(() => {
        this.filterGrid.setAllowSubmit(false);
      });
    }

    this._onStateUpdate = this.onStateUpdate.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();

    // Await other components to initialize
    customElements.whenDefined('filter-grid').then(() => {
      this.onStateUpdate();
    });
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    if (this.filterGrid) {
      this.filterGrid.addEventListener('change', this._onStateUpdate);
    }
  }
  removeEventListeners() {
    if (this.filterGrid) {
      this.filterGrid.removeEventListener('change', this._onStateUpdate);
    }
  }

  getState() {
    let state = {};
    if (this.filterGrid) {
      state = this.filterGrid.getState();
    }
    return state;
  }

  onStateUpdate() {
    this.state = this.getState();

    this.items.forEach(item => {
      let show = true;
      for (let key in this.state) {
        let inputType = 'single';
        if (Array.isArray(this.state[key])) inputType = 'multi';
        if (key.match(/range/)) inputType = 'range';
        if (key.match(/search/)) inputType = 'search';

        if (this.state[key].length > 0) {
          let itemValue = item.getAttribute('data-' + key.replace(/_/g, '-'));

          if (inputType === 'multi') {
            itemValue = itemValue.split(',');
            let match = itemValue.filter(value => this.state[key].includes(value));
            if (this.state[key].length > 0 && match.length === 0) {
              show = false;
              continue;
            }
          }

          if (inputType == 'single') {
            if (!this.state[key] != itemValue) {
              show = false;
              continue;
            }
          }

          if (inputType === 'search') {
            itemValue = item.textContent.trim();
            if (itemValue.toLowerCase().indexOf(this.state[key].toLowerCase()) === -1) {
              show = false;
              continue;
            }
          }

          if (inputType === 'range' && key.match(/min/)) {
            let itemValueMin = itemValue;
            let maxKey = key.replace(/min/, 'max');
            let itemValueMax = item.getAttribute(
              'data-' + maxKey.replace(/_/g, '-').replace(/min/, ''),
            );
            let rangeValueMin = this.state[key] * 1;
            let rangeValueMax = this.state[maxKey] * 1;

            if (rangeValueMax < itemValueMin * 1 || rangeValueMin > itemValueMax * 1) {
              show = false;
              continue;
            }
          }
        }
      }

      if (show) {
        item.parentNode.removeAttribute('hidden');
      } else {
        item.parentNode.setAttribute('hidden', true);
      }
    });
  }
}

customElements.define('card-grid-filter', CardGridFilter);
